<template>
  <transition name="layer">
    <div class="exchange_layer" v-if="exchangeLayerUrl">
      <div class="layer_deco">
        <div class="layer">
          <iframe
            ref="iframe"
            id="exchangeLayer"
            name="exchangeLayer"
            :src="exchangeLayerUrl"
            title="포인트 전환 신청 레이어"
          ></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/utils/eventBus';

export default {
  data() {
    return {
      isExchangeLayer: true,
      rendingUrl: '',
    };
  },
  computed: {
    ...mapGetters(['serviceUrl', 'exchangeLayerUrl']),
  },
  methods: {
    ...mapActions(['setExchangeLayerUrl']),
    handleClick() {
      this.setExchangeLayerUrl('');
    },
    iframeReset() {
      this.setExchangeLayerUrl('');
      this.$nextTick(() => {
        this.setExchangeLayerUrl(`/${this.$root.$i18n.locale}/${this.serviceUrl}/exchange/step1`);
      });
    },
  },
  mounted() {
    eventBus.$on('iframeReset', this.iframeReset);
  },
  beforeDestroy() {
    eventBus.$off('iframeReset', this.iframeReset);
  },
};
</script>
